import { CdkStore } from 'drive-ui-packages';
import { DepartmentIds } from 'adapters/types/Client';

export const getStoreName = (
  stores: CdkStore[],
  storeId: string | undefined
): string => stores.find(store => store.storeId === storeId)?.name || '';

export const getDepartmentId = (
  departmentIds: DepartmentIds[] | null,
  storeId: string | undefined
): string =>
  departmentIds?.find(departments => departments.storeId === storeId)
    ?.departmentIds || '';
